import { ShoppingBag } from "lucide-react";
import React from "react";
import { FaFacebookF, FaTwitter, FaInstagram, FaLinkedinIn, FaYoutube } from "react-icons/fa";


export default function FooterCard10() {
  return (<>
    <footer className="va-footer-fc-10">

      <div className="footer-fc-10-top">
        {/* Brand + Description */}
        <div className="footer-fc-10-col brand-fc-10-col">
          <div className="brand-fc-10-logo">
            <span className="brand-fc-10-icon"><ShoppingBag size={20} /></span>
            <h2>Virtual Assistant</h2>
          </div>

          <p>
            Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do
            eiusmod tempor incididunt ut labore et dolore magna aliqua.
            Temporibus eveniet, quis nostrum exercitation ullamco nisi ut
            aliquip ex ea commodo consequat.
          </p>

          <div className="social-fc-10-row">
            <span>Social Icons:</span>
            <div className="social-fc-10-icons">
              <span><FaFacebookF />
                        </span>
              <span>  <FaTwitter />
                       </span>
              <span>   <FaInstagram />
                          </span>
              <span><FaLinkedinIn />
                         </span>
            </div>
          </div>
        </div>

        {/* Quick Links */}
        <div className="footer-fc-10-col">
          <h3>Quick Links</h3>
          <ul>
            <li>About Us</li>
            <li>Blogs</li>
            <li>Booking</li>
            <li>Contact</li>
            <li>Faq</li>
          </ul>
        </div>

        {/* Legal Info */}
        <div className="footer-fc-10-col">
          <h3>Legal Information</h3>
          <ul>
            <li>Privacy Policy</li>
            <li>Terms & Condition</li>
            <li>Refund Policy</li>
          </ul>

          <button className="buy-btn-fc-10">Buy Now</button>
        </div>

        {/* Contact Info */}
        <div className="footer-fc-10-col">
          <h3>Call Now for Service</h3>
          <p>123, New Lenox Chicago, IL 60606</p>
          <p>+1 (555) 123-4567</p>
        </div>
      </div>

      <div className="footer-fc-10-bottom">
        © 2025 – VW Virtual Assistant Pro All rights reserved.
      </div>
    </footer>
    <style>{`.va-footer-fc-10 {
  position: relative;
  background: #0d0d0f;
  color: white;
  padding: 120px 70px 40px; /* extra top spacing for waves */
  font-family: Arial, sans-serif;
  overflow: hidden;
}

/* ---------------------- */
/*  PURPLE CURVED BLOB    */
/* ---------------------- */

.va-footer-fc-10::before {
  content: "";
  position: absolute;
  top: -140px;
  right: -180px;
  width: 480px;
  height: 480px;
  background: rgba(144, 202, 249,1);
  border-radius: 50%;
  filter: blur(40px);
  opacity: 0.85;
  z-index: 0;
}

/* ---------------------- */
/*  CURVED WAVE DIVIDER   */
/* ---------------------- */

.va-footer-fc-10::after {
  content: "";
  position: absolute;
  top: 0;
  left: -200px;
  width: 120%;
  height: 180px;

  background: rgba(144, 202, 249,1);

  border-bottom-left-radius: 50% 100%;
  border-bottom-right-radius: 50% 100%;

  transform: translateY(-90%);
  z-index: 1;
}

.footer-fc-10-top {
  position: relative;
  z-index: 2;
  display: grid;
  grid-template-columns: 2fr 1fr 1fr 1fr;
  gap: 50px;
}

/* BRAND SECTION */
.brand-fc-10-col p {
  margin-top: 15px;
  line-height: 1.6;
  max-width: 430px;
}

.brand-fc-10-logo {
  display: flex;
  align-items: center;
  gap: 12px;
}

.brand-fc-10-icon {
  background: rgba(144, 202, 249,1);
  padding: 15px 18px;
  border-radius: 50%;
  font-size: 24px;
}

/* SOCIAL ICONS */
.social-fc-10-row {
  margin-top: 20px;
}
.social-fc-10-icons {display:flex;justify-content:center;}

.social-fc-10-icons span {
  background: #fff; margin-top: 20px;display:flex;justify-content:center;align-items:center;
  color: #000;
  width:40px;height:40px;
  margin-right: 8px;
  border-radius: 4px;
  cursor: pointer;
}

/* COLUMN TITLES */
.footer-fc-10-col h3 {
  margin-bottom: 10px;
  font-size: 18px;
}

.footer-fc-10-col ul {
  list-style: none;
  padding: 0;
  margin-top: 10px;
}

.footer-fc-10-col ul li {
  margin: 8px 0;
  cursor: pointer;
  opacity: 0.9;
}

.footer-fc-10-col ul li:hover {
  opacity: 1;
}

/* BUY BUTTON */
.buy-btn-fc-10 {
  margin-top: 15px;
  padding: 8px 18px;
  border: none;
  background: rgba(144, 202, 249,1);
  color: white;
  border-radius: 6px;
  cursor: pointer;
}
.buy-btn-fc-10:hover {
  background: rgba(144, 202, 249,1);
}

/* FOOTER BOTTOM */
.footer-fc-10-bottom {
  margin-top: 40px;
  text-align: center;
  padding-top: 20px;
  border-top: 1px solid #333;
  font-size: 14px;
  opacity: 0.7;
  position: relative;
  z-index: 3;
}

`}</style>
    </>
  );
}
